import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container } from 'geniebook-ui/dist';
import useHideBottomNavbar from '@utils/helpers/useHideBottomNavbar';
import { subjectIdFromName } from '@utils/helpers/SubjectParser';
import {
  resetToDefaultNavbarState,
  setNavbarWithTitleWithTopNavbar,
} from '@atom/navbarAtom';
import { BackgroundContainer } from '@assets/styles/background.style';

const CreateRevisionWorksheet = React.lazy(
  () => import('geniesmart/CreateRevisionWorksheet'),
);

const CreateRevisionWorksheetPage = () => {
  useHideBottomNavbar();

  useEffect(() => {
    setNavbarWithTitleWithTopNavbar('Create Worksheet');
    return () => {
      resetToDefaultNavbarState();
    };
  });

  const { subjectId } = useParams();
  const navigate = useNavigate();

  return (
    <BackgroundContainer>
      <Container className={'max-lg:pt-6 lg:pt-10'}>
        <CreateRevisionWorksheet
          subjectSlug={subjectId ?? ''}
          subjectId={subjectIdFromName(subjectId ?? '')}
          onNavigation={(navigation: string) => {
            navigate(navigation);
          }}
        />
      </Container>
    </BackgroundContainer>
  );
};

export default CreateRevisionWorksheetPage;
